import React, { useState, useContext } from "react";
import { Link } from "gatsby";
import NavbarMobile from "./NavbarMobile";
import { getNavOptionsByLogin } from "../../data/navbar-options";
import { Fragment } from "react";
import NavbarOptions from "./NavbarOptions";
import { AuthContext } from "../../contexts/AuthContext";

export default function Navbar(props) {
  const { openMenu, className, withoutNavOptions } = props;
  const { userInfo } = useContext(AuthContext);
  const [navbar] = useState(getNavOptionsByLogin());

  const renderItem = (linkData) => {
    if ("options" in linkData)
      return (
        <Fragment>
          <Link to={linkData.link} className="Navbar-link">
            {linkData.title}
          </Link>
          <i className="fas fa-caret-down"></i>
          <NavbarOptions list={linkData.options} />
        </Fragment>
      );
    return (
      <Link to={linkData.link} className="Navbar-link">
        {linkData.title}
      </Link>
    );
  };

  const renderOptions = () => {
    return (
      navbar &&
      navbar.map((item, index) => {
        if ("val" in item && !item.val(userInfo)) return null;
        return (
          <li className="Navbar-item" key={`navbar-${index}`}>
            {renderItem(item)}
          </li>
        );
      })
    );
  };

  const renderMobileOptions = () => {
    return (
      navbar &&
      navbar.map((item, index) => {
        if ("val" in item && !item.val(userInfo)) return null;
        return (
          <NavbarMobile
            noOption
            title={item.title}
            link={item.link}
            key={`mobila-option-${index}`}
          />
        );
      })
    );
  };

  return (
    <div className={`Navbar ${className}`}>
      <div className="Navbar-container">
        <div className="Navbar-menu menu-intranet d-none d-md-block">
          <ul className="Navbar-list">
            {!withoutNavOptions && renderOptions()}
          </ul>
        </div>
        <div
          className={
            openMenu
              ? "Navbar-menu menu-intranet d-block"
              : "Navbar-menu menu-intranet d-none"
          }
        >
          <ul className="Navbar-list">
            {!withoutNavOptions && renderMobileOptions()}
          </ul>
        </div>
      </div>
    </div>
  );
}
